import http from "@/http/aisea/axios";

export default {
  // 燃料消費統計レポートAPI
  report(payload) {
    return http.get(`secure_dataflow/enterprise/engine/yearly/fuel/report/${payload.vessel_id}/${payload.yyyy}`, { responseType : 'blob' });
  },
};
